<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top">
            <el-form-item
              label="照片 ："
              prop="picture"
            >
              <el-upload
                class="avatar-uploader"
                :headers="headers"
                :action="$baseUrl +'/api/file/upload'"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="formData.picture" :src="$baseUrl+formData.picture" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="姓名 ："
              prop="name"
            >
              <el-input v-model="formData.name" placeholder="请输入姓名" />
            </el-form-item>
            <el-form-item
              label="手机号 ："
              prop="phone"
            >
              <el-input v-model="formData.phone" placeholder="请输入手机号" maxlength="11" show-word-limit />
            </el-form-item>
            <el-form-item
              label="性别 ："
              prop="sex"
            >
              <el-select v-model="formData.sex" placeholder="请选择性别" style="width: 100%;">
                <el-option label="男" value="男" />
                <el-option label="女" value="女" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="出生日期 ："
              prop="birthDate"
            >
              <el-date-picker
                style="width: 100%"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="formData.birthDate"
                type="date"
                placeholder="选择出生日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="籍贯 ："
              prop="nativePlace"
            >
              <el-input v-model="formData.nativePlace" placeholder="请输入籍贯" />
            </el-form-item>
            <el-form-item
              label="专业 ："
              prop="major"
            >
              <el-input v-model="formData.major" placeholder="请输入专业" />
            </el-form-item>
            <el-form-item
              label="党派 ："
              prop="partyAffiliation"
            >
              <el-input
                v-model="formData.partyAffiliation"
                placeholder="请输入党派"
              />
            </el-form-item>
            <el-form-item
              label="民族 ："
              prop="nation"
            >
              <el-input v-model="formData.nation" placeholder="请输入民族" />
            </el-form-item>
            <el-form-item
              label="文化程度 ："
              prop="degreeEducation"
            >
              <el-input
                v-model="formData.degreeEducation"
                placeholder="请输入文化程度"
              />
            </el-form-item>
            <el-form-item
              label="本会职务 ："
              prop="duty"
            >
              <el-input v-model="formData.duty" placeholder="请输入本会职务" />
            </el-form-item>
            <el-form-item
              label="技术职称与级别 ："
              prop="title"
            >
              <el-input
                v-model="formData.title"
                placeholder="请输入技术职称与级别"
              />
            </el-form-item>
            <el-form-item
              label="工作单位及职务 ："
              prop="workUnit"
            >
              <el-input
                v-model="formData.workUnit"
                placeholder="请输入工作单位及职务"
              />
            </el-form-item>
            <el-form-item
              label="学位 ："
              prop="academicDegree"
            >
              <el-input
                v-model="formData.academicDegree"
                placeholder="请输入学位"
              />
            </el-form-item>
            <el-form-item
              label="通讯处 ："
              prop="address"
            >
              <el-input v-model="formData.address" placeholder="请输入通讯处" />
            </el-form-item>
            <el-form-item
              label="邮编 ："
              prop="postalCode"
            >
              <el-input v-model="formData.postalCode" placeholder="请输入邮编" />
            </el-form-item>
            <el-form-item
              label="微信 ："
              prop="wechat"
            >
              <el-input v-model="formData.wechat" placeholder="请输入微信" />
            </el-form-item>
            <el-form-item
              label="学历 ："
              prop="education"
            >
              <el-input v-model="formData.education" placeholder="请输入学历" />
            </el-form-item>
            <el-form-item
              label="重要科技发明、著作、学术论文(何时、何地出版或发表) ："
              prop="invent"
            >
              <el-input
                v-model="formData.invent"
                placeholder="请输入重要科技发明、著作、学术论文(何时、何地出版或发表)"
              />
            </el-form-item>
            <el-form-item
              label="受过何种奖励 ："
              prop="reward"
            >
              <el-input
                v-model="formData.reward"
                placeholder="请输入受过何种奖励"
              />
            </el-form-item>
            <el-form-item
              label="懂何种外语 ："
              prop="languages"
            >
              <el-input
                v-model="formData.languages"
                placeholder="请输入懂何种外语"
              />
            </el-form-item>
            <el-form-item
              label="备注 ："
              prop="remark"
            >
              <el-input v-model="formData.remark" placeholder="请输入备注" />
            </el-form-item>
            <!-- <el-form-item
              label="会员证编码"
              prop="memberCode"
            >
              <el-input
                v-model="formData.memberCode"
                placeholder="请输入会员证编码"
                auto-complete="new-password"
              />
            </el-form-item> -->
            <el-form-item
              label="密码"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                placeholder="请输入密码"
                auto-complete="new-password"
              />
            </el-form-item>
            <el-form-item>
              <el-button style="width: 100%;" type="primary" @click="submitForm('formData')" v-loading="login_loading">立即注册(需支付会费{{payMoney}}元)</el-button>
            </el-form-item>
            
        </el-form>
        <el-dialog
          title="微信扫描二维码支付会费"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          width="90%"
          :before-close="handleClose"
          >
          <div ref="qrCodeUrl" style="display: none;"></div>
          <div ref="qrCodeUrl2"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="zhuceFun()">支付完成，提交注册</el-button>
          </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { userRegister,createOrder,getPayMsg,commodity } from "@/api/g_login";
  import QRCode from 'qrcodejs2'
  export default {
    data(){
      return{
        headers:{
          "token":localStorage.getItem("foregroundToken")
        },
        formData: {
            picture: "",
            name: "",
            phone: "",
            sex: "",
            birthDate: "",
            nativePlace: "",
            major: "",
            partyAffiliation: "",
            nation: "",
            degreeEducation: "",
            duty: "",
            title: "",
            workUnit: "",
            academicDegree: "",
            address: "",
            postalCode: "",
            wechat: "",
            education: "",
            invent: "",
            reward: "",
            languages: "",
            remark: "",
            // memberCode: "",
            password: "",
        },
        rules: {
            picture: [{ required: true, message: "请上传头像", trigger: "blur" }],
            name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
            phone: [
              { required: true, message: "请输入联系方式", trigger: "blur" },
              {
                pattern: /^1[3,4,5,6,7,8,9][0-9]{9}$/,
                message: "联系方式格式有误！",
                trigger: "blur",
              },
            ],
            sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
            birthDate: [{ required: true, message: "请输入出生日期", trigger: "blur" }],
            nativePlace: [{ required: true, message: "请输入籍贯", trigger: "blur" }],
            major: [{ required: true, message: "请输入专业", trigger: "blur" }],
            partyAffiliation: [
              { required: true, message: "请输入党派", trigger: "blur" },
            ],
            nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
            degreeEducation: [
              { required: true, message: "请输入文化程度", trigger: "blur" },
            ],
           
            duty: [{ required: true, message: "请输入本会职务", trigger: "blur" }],
            title: [{ required: true, message: "请输入技术职称与级别", trigger: "blur" }],
            workUnit: [
              { required: true, message: "请输入工作单位及职务", trigger: "blur" },
            ],
            academicDegree: [{ required: true, message: "请输入学位", trigger: "blur" }],
            address: [{ required: true, message: "请输入通讯处", trigger: "blur" }],
            postalCode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
            wechat: [{ required: true, message: "请输入微信", trigger: "blur" }],
            education: [{ required: true, message: "请输入学历", trigger: "blur" }],
            invent: [
              {
                required: true,
                message: "请输入重要科技发明、著作、学术论文(何时、何地出版或发表)",
                trigger: "blur",
              },
            ],
            reward: [{ required: true, message: "请输入受过何种奖励", trigger: "blur" }],
            languages: [{ required: true, message: "请输入懂何种外语", trigger: "blur" }],
            remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
            // memberCode: [
            //   { required: true, message: "请输入会员证编码", trigger: "blur" },
            // ],
            password: [
              { required: true, message: "请输入密码", trigger: "blur" },
            ],
        },
        login_loading:false,
        dialogVisible: false,
        orderNo:'',
        payMoney:'',
      }
    },
    mounted(){
      commodity().then((res)=>{
        this.payMoney = res.data[0].monney
      })
    },
    methods:{
      onBridgeReady(data) {
		    WeixinJSBridge.invoke('getBrandWCPayRequest', {
		        "appId": data.appId,     //公众号ID，由商户传入     
		        "timeStamp": data.timeStamp,     //时间戳，自1970年以来的秒数     
		        "nonceStr": data.nonceStr,      //随机串     
		        "package": data.package,
		        "signType": data.signType,     //微信签名方式：     
		        "paySign": data.paySign//微信签名 
		    },
		    (res)=> {
		        if (res.err_msg == "get_brand_wcpay_request:ok") {
		            // 使用以上方式判断前端返回,微信团队郑重提示：
		            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
								console.log('jdhfskujhfgjd',res);
                // 支付完回调
                this.$confirm('注册申请已提交，请耐心等待审核', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  type: 'success'
                }).then(() => {
                  window.location.replace(this.$baseUrl+'/#/indexPage')
                })
                // this.$message({message: '注册申请已提交，请耐心等待审核',type: 'success'});
                // setTimeout(() => {
                //  window.location.replace(this.$baseUrl+'/#/indexPage')
                // }, 1000);
		          }
		    });
		  },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
        if (valid) {
            this.login_loading = true
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('micromessenger') !== -1) {
              // 当前页面在微信中打开
              getPayMsg(this.formData).then((res)=>{
                window.location.href = this.$baseUrl+'/api/wx/jsPay?orderNo='+res.data
              }).finally(()=>{
                this.login_loading = false
              })
            } else {
               // 当前页面不在微信中打开(生成二维码)
              createOrder(this.formData).then((res)=>{
                    this.login_loading = false
                    this.dialogVisible = true
                    this.orderNo = res.data.orderNo
                    setTimeout(() => {
                        new QRCode(this.$refs.qrCodeUrl, {
                            text: res.data.url, // 需要转换为二维码的内容
                            width: 100,
                            height: 100,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: QRCode.CorrectLevel.H
                        })
                        let image = new Image();
                        image.src = this.$refs.qrCodeUrl.firstChild.toDataURL("image/png");
                        this.$refs.qrCodeUrl2.appendChild(image);
                    }, 200);
              }).finally(()=>{
                this.login_loading = false
              })
            }
            
          } else {
            return false;
          }
        });
      },
      zhuceFun(){
        userRegister({...this.formData,orderNo:this.orderNo}).then((res)=>{
            this.$confirm('注册申请已提交，请耐心等待审核', '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              type: 'success'
            }).then(() => {
              window.location.replace(this.$baseUrl+'/#/indexPage')
            })
        }).finally(()=>{
          this.login_loading = false
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleAvatarSuccess(res) {
        this.formData.picture = res.data.filePath
        console.log(this.formData.picture);
      },
      handleClose() {
        this.login_loading = false
        this.orderNo = ''
        this.dialogVisible = false
      }
    }
  }
  </script>
  <style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>